import React, { useState } from "react";
import PropTypes from "prop-types";
import DocumentTransitionsComponent from "./DocumentTransitionsComponent";
import { useQueryWithSimpleErrorHandling } from "hooks";
import { DOCUMENT_STATE_TRANSITIONS } from "../queries";

const DocumentTransitionsContainer = ({ documentAttachmentId, onCloseModal }) => {
  const [stateTransitions, setStateTransitions] = useState([]);

  const { loading } = useQueryWithSimpleErrorHandling(DOCUMENT_STATE_TRANSITIONS, {
    variables: { documentAttachmentId },
    fetchPolicy: "network-only",
    onCompleted: ({ documentStateTransitions }) => {
      setStateTransitions(documentStateTransitions);
    }
  });

  return (
    <DocumentTransitionsComponent loading={loading} stateTransitions={stateTransitions} onCloseModal={onCloseModal} />
  );
};

DocumentTransitionsContainer.propTypes = {
  documentAttachmentId: PropTypes.number.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default DocumentTransitionsContainer;
